module.exports = __webpack_public_path__ + "img/avatar-s-17.a92e96b2.png";